export const articlesList = getters => {
  return getters.articlesList
}

export const articleThemesList = getters => {
  return getters.articleThemesList
}
